import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Edit, AlertCircle, Save } from 'lucide-react';
import { formatDateTimeWithTimezone } from '../../utils/timezone';

export const EditEntryDialog = ({ open, onOpenChange, entry, form, setForm, onSave, isLoading, userTimezone }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl">
      <DialogHeader>
        <DialogTitle className="flex items-center space-x-2">
          <Edit className="w-6 h-6 text-blue-600" />
          <span>Edit Time Entry</span>
        </DialogTitle>
        <DialogDescription>Editing time for: {entry?.user_name}</DialogDescription>
      </DialogHeader>

      {entry?.edited && (
        <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
          <div className="flex items-start space-x-2">
            <AlertCircle className="w-5 h-5 text-orange-600 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-orange-900">Previously Edited</p>
              <p className="text-xs text-orange-700 mt-1">
                By {entry.edited_by_name} on {formatDateTimeWithTimezone(entry.edited_at, userTimezone)}
              </p>
              {entry.edit_reason && (
                <p className="text-xs text-orange-700 mt-1">Reason: {entry.edit_reason}</p>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label>Clock In Date</Label>
            <Input type="date" value={form.clock_in_date} onChange={(e) => setForm({ ...form, clock_in_date: e.target.value })} className="h-11" />
          </div>
          <div>
            <Label>Clock In Time</Label>
            <Input type="time" value={form.clock_in_time} onChange={(e) => setForm({ ...form, clock_in_time: e.target.value })} className="h-11" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label>Clock Out Date</Label>
            <Input type="date" value={form.clock_out_date} onChange={(e) => setForm({ ...form, clock_out_date: e.target.value })} className="h-11" />
          </div>
          <div>
            <Label>Clock Out Time</Label>
            <Input type="time" value={form.clock_out_time} onChange={(e) => setForm({ ...form, clock_out_time: e.target.value })} className="h-11" />
          </div>
        </div>

        <div>
          <Label>Reason for Edit (Required)</Label>
          <Textarea
            value={form.reason}
            onChange={(e) => setForm({ ...form, reason: e.target.value })}
            placeholder="E.g., Correcting missed clock out, adjusting for approved overtime"
            rows={3}
          />
        </div>

        <div className="flex space-x-3">
          <Button onClick={onSave} disabled={isLoading || !form.reason} className="flex-1 bg-blue-600 hover:bg-blue-700">
            <Save className="w-4 h-4 mr-2" />
            Save Changes
          </Button>
          <Button onClick={() => onOpenChange(false)} variant="outline" className="flex-1">
            Cancel
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
